export const ProjectCategoryItems = [
    {
        name: 'Latest Projects',
        variable: 'latestProjects',
        icon: 'latest-icon.png',
        isExpanded: true,
    },
    {
        name: 'Mobile Projects',
        variable: 'mobileProjects',
        icon: 'mobile-icon.png',
        isExpanded: false,
    },
    {
        name: 'Wearable Projects',
        variable: 'wearableProjects',
        icon: 'wearable-icon.png',
        isExpanded: false,
    },
    {
        name: 'Other Projects',
        variable: 'otherProjects',
        icon: 'pc-icon.png',
        isExpanded: false,
    },
];